export default {"src":"/trader-new/_next/static/media/rewards.37e4ee44.svg","height":620,"width":636,"blurWidth":0,"blurHeight":0};